import { when, set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import hasFocusedTag from '../actions/hasFocusedTag'
import hasTags from '../actions/hasTags'
import focusLastTag from '../actions/focusLastTag'
import removeFocusedTag from '../actions/removeFocusedTag'

const onBackSpace = hooks => {
  return [
    when(
      state`selectr.${props`namespace`}.input.value`,
      value => value.length === 0
    ),
    {
      true: [
        hasTags,
        {
          true: [
            hasFocusedTag,
            {
              true: [
                removeFocusedTag,
                set(state`selectr.${props`namespace`}.focusedTag`, null),
                set(
                  state`selectr.${props`namespace`}.performTagUnfocus`,
                  false
                ),
                set(state`selectr.${props`namespace`}.focusInput`, true),
                set(props`payload`, state`selectr.${props`namespace`}.payload`),
                ...hooks.unSelectOption
              ],
              false: [
                focusLastTag,
                set(state`selectr.${props`namespace`}.performTagUnfocus`, true)
              ]
            }
          ],
          false: []
        }
      ],
      false: []
    }
  ]
}

export default onBackSpace
